import dragscroll from './module/dragscroll'
import hasPerm from './module/hasPermi'

const directives = {
	dragscroll,
	hasPerm
}

export default directives
